module.exports = __webpack_public_path__ + "img/platinum.f8c4e0c8.svg";